import React from 'react'


const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="copyright">
                <li><span className="label">2018 &copy; Mike Hancock</span></li>
                <li><a href="mailto:contact@mikehancock.com">contact@mikehancock.com</a></li>
                <li><a href="/about">about</a></li>
                <li><a href="/contact-me">contact</a></li>
                <li><a href="/sitemap.xml">sitemap</a></li>
                
            </ul>
        </div>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js